module.exports = __webpack_public_path__ + "img/icon_4.ba908a6e.png";